module.exports = __webpack_public_path__ + "static/media/help_templates.9da96981.png";